import React from 'react';
import {
    Box,
    Chip,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {
    FilterListRounded,
    PeopleAltRounded,
} from "@mui/icons-material";
import SearchTextField from "../../../components/SearchTextField";

const _UserListFilters = ({
    selectedGroup,
    setSelectedGroup,
    groups,
    setSearchText,
    totalCount,
}) => {
    return (
        <Box
            sx={{
                p: { xs: 2, sm: 2.5 },
                borderBottom: '1px solid',
                borderColor: 'divider',
                bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.02)' : 'rgba(0, 0, 0, 0.015)'
            }}
        >
            <Grid container spacing={2} alignItems="center">
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                    <FormControl fullWidth size="small">
                        <InputLabel id="user-groups-label" sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                            <FilterListRounded fontSize="small" />
                            فیلتر بر اساس گروه
                        </InputLabel>
                        <Select
                            labelId="user-groups-label"
                            id="user-groups-select"
                            value={selectedGroup ?? ""}
                            label="فیلتر بر اساس گروه"
                            onChange={(e) => setSelectedGroup(e.target.value === "" ? null : e.target.value)}
                            sx={{ borderRadius: 2.5 }}
                        >
                            <MenuItem value="">
                                <em>همه کارمندان (تمام گروه‌ها)</em>
                            </MenuItem>
                            {groups?.map((item) => (
                                <MenuItem key={item.Id} value={item.Id}>
                                    {item.Name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 5 }}>
                    <SearchTextField
                        label="جستجوی نام و مشخصات کارمند..."
                        size="small"
                        fullWidth
                        onChange={(e) => setSearchText(e)}
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2.5 } }}
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 3 }} sx={{ display: 'flex', justifyContent: { xs: 'flex-start', md: 'flex-end' } }}>
                    <Chip
                        icon={<PeopleAltRounded sx={{ fontSize: 18 }} />}
                        label={`تعداد کارمندان: ${totalCount}`}
                        variant="outlined"
                        sx={{
                            fontWeight: 700,
                            borderRadius: 2,
                            py: 1.8,
                            borderColor: 'divider',
                            bgcolor: 'background.paper'
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default _UserListFilters;
